import base from './base'; //base urls list
import axios from '../https';//axios instance
const env = base.backend
const adviserdashboard_api = { 
    // get all the smsf of this user   
    smsfList(brand){   
        return axios.get(`${env}/api/smsf/${brand}/retrieve_all/`);    
    },    
    //get market value and trend
    marketValue(brand){   
        return axios.get(`${env}/api/marketvalue/${brand}/retrieve_balance_all/`);    
    }, 
    //get investments
    InvestmentsData(brand){   
        return axios.get(`${env}/api/investment/${brand}/retrieve_brand/`);    
    }, 
    memberAgeProfile(brand){
        return axios.get(`${env}/api/trustee/${brand}/retrieve_ages/`);   
    },
    pensionInfo(brand){
        return axios.get(`${env}/api/pension/${brand}/retrieve_pensions/`);   
    },
    contributionInfo(brand){
        return axios.get(`${env}/api/contribution/${brand}/retrieve_contributions/`);   
    },
    insuranceInfo(brand){
        return axios.get(`${env}/api/trustee/${brand}/retrieve_insurance/`);   
    },
    trustee_structure(brand){
        return axios.get(`${env}/api/smsf/${brand}/trustee_structure/`);   
    },
    get_accrium_feeds(){
        return axios.get(`${env}/api/feeds/`);   
    },
    service_requests(brand){
        return axios.get(`${env}/api/smsf/${brand}/service_requests/`);   
    },
    servicecenter(form){
        return axios.post(`${env}/api/servicecenter/`, form);   
    },
    fund_status_adviser(brand){
        return axios.get(`${env}/api/smsf/${brand}/fund_status_adviser/`);   
    },
    cash(brand){
        return axios.get(`${env}/api/smsf/${brand}/adviser_cash/`);  
    },
    contributions(brand){
        return axios.get(`${env}/api/contribution/${brand}/contributions/`);   
    },
    pensions(brand){
        return axios.get(`${env}/api/pension/${brand}/pensions/`);   
    },
    insurance(brand){
        return axios.get(`${env}/api/trustee/${brand}/insurance/`);   
    },
    adviser_tax(brand){
        return axios.get(`${env}/api/smsf/${brand}/adviser_tax/`);   
    },
    tax_outstanding(brand){
        return axios.get(`${env}/api/smsf/${brand}/tax_outstanding/`);   
    },
    age_notifications(brand){
        return axios.get(`${env}/api/trustee/${brand}/age_notifications/`);   
    },
    audit_notifications(brand){
        return axios.get(`${env}/api/smsf/${brand}/audit_notifications/`);   
    },
    // .....
}

export default adviserdashboard_api;